<h2 mat-dialog-title>Documentos Entrega</h2>
<mat-dialog-content class="mat-typography">
    <div class="contenedor-form" *ngIf="loading">
        <mat-spinner [diameter]="100" style="margin:0 auto; top:15px;"></mat-spinner>
      </div>
  <p>Imagen Adjunto</p>
  <div class="row" *ngFor="let imagen of imagenes">
    <div class="col s12 m12 l12">
      <img [hidden]="loading"   style="width: 100%;" [src]="imagen" />
      <mat-divider></mat-divider>
    </div>
  </div>

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button color="accent" (click)="crearPDF();" >PDF</button>
  <button mat-raised-button color="primary" [mat-dialog-close]="dataModified" cdkFocusInitial>Cerrar</button>
</mat-dialog-actions>
